<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="screen-message">
      <div class="message-item text-center">
        <h1>
          <span>無料相談に応募しました。</span>
        </h1>
        <p v-if="false">少々お待ちください。</p>
        <p v-if="false">待っても画面が変わらない場合は下記のボタンをクリックしてください。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      fullscreenLoading: false
    }
  },
  methods: {

    goJobdetail: function () {
      const formData = new FormData()
      formData.append('uuid', this.$route.query.uuid)
      formData.append('format_id', this.$route.query.mailmagaid)
      formData.append('keyword', this.$route.query.keyword)
      formData.append('jt', this.$route.query.jt)
      formData.append('area', this.$route.query.area)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      if (this.$route.query.mailmagaid) {
        formData.append('site_flag', 'g')
      } else {
        formData.append('site_flag', 'm')
      }
      formData.append('app_flag', this.$site.appFlag)

      formData.append('st', this.$route.query.st)
      formData.append('mailmaga_id', this.$route.query.mailmagaid)
      formData.append('title', this.$route.query.title)
      formData.append('company', this.$route.query.company)
      // formData.append('snippet', this.$route.query.snippet)
      formData.append('clicklink', this.$route.query.joburl)

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, { timeout: 60000 })
      location.href = this.redirectURL
    },
    sendRealtimeTransfer15: async function () {
      const app = this
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', "-")
      formData.append('apikey', "-")
      formData.append('app_html', "-")
      formData.append('pdf_option', 'A4')
      formData.append('uuid', this.$route.query.ud)
      formData.append('dialog_name', 'rt_1_5_mail')
      formData.append('client_id', this.$route.query.ci)
      formData.append('permission_type', this.$route.query.pt)
      formData.append('rt_mail_history_id', this.$route.query.hid)
      formData.append('format_id', this.$route.query.fid)

      formData.append('yaginame', "ヤギ")
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', "-")
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendRealtimeTransfer15, formData, { timeout: 60000 })
        .then(function (response) {

        })
        .catch(function (error) {
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendRoxxConsult: async function () {
      const app = this
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', "-")
      formData.append('apikey', "-")
      formData.append('app_html', "-")
      formData.append('pdf_option', 'A4')
      formData.append('uuid', this.$route.query.ud)
      formData.append('format_id', 'pdf_mail_rt1.5')
      formData.append('dialog_name', 'pdf_mail_dialog')
      formData.append('permission_type', this.$route.query.pt)
      formData.append('rt_mail_history_id', this.$route.query.hid)

      formData.append('yaginame', "ヤギ")
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', "-")
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendDataRoxx, formData, { timeout: 60000 })
        .then(function (response) {

        })
        .catch(function (error) {
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
  },
  created: function () {
    this.sendRoxxConsult()

  }
}
</script>
